export default "__VITE_ASSET__DxR0C63u__"